import { EPDStatusDisplayName } from 'services/EpdClient';

export type YesNo = 'Yes' | 'No';

export const YES_NO = {
  YES: 'Yes' as const,
  NO: 'No' as const,
};

export const YesNoDataSource = [
  { value: YES_NO.YES, label: YES_NO.YES },
  { value: YES_NO.NO, label: YES_NO.NO },
];

export const EPDStatusDisplayNameDataSource = [
  { value: EPDStatusDisplayName.Reserved, label: 'Reserved' },
  { value: EPDStatusDisplayName.SentForVerification, label: 'Sent for verification' },
  { value: EPDStatusDisplayName.ReadyToPublish, label: 'Ready to publish' },
  { value: EPDStatusDisplayName.SentForPublication, label: 'Sent for publication' },
  { value: EPDStatusDisplayName.Updating, label: 'Updating' },
  { value: EPDStatusDisplayName.Published, label: 'Published' },
  { value: EPDStatusDisplayName.DeclinedPublication, label: 'Declined publication' },
  { value: EPDStatusDisplayName.Depublished, label: 'Depublished' },
  { value: EPDStatusDisplayName.Deregistered, label: 'Deregistered' },
  { value: EPDStatusDisplayName.DeclinedVerification, label: 'Declined verification' },
];

export const ISO_14025_ID = '1';
export const EN_158042012_ID = '2';
export const ISO_21930_ID = '3';

export const EPDProductClassificationId = {
  SINGLE_PRODUCT_ID: 1,
  MULTIPLE_PRODUCTS_BASED_ON_AVG_RESULTS_ID: 2,
  MULTIPLE_PRODUCTS_BASED_ON_REPRESENTATIVE_PRODUCT_ID: 3,
  MULTIPLE_PRODUCTS_BASED_ON_WORST_CASE_RESULTS_ID: 4,
  SECTOR_OF_MULTIPLE_PRODUCTS_ID: 5,
  SECTOR_OF_AVERAGE_PRODUCTS_ID: 6,
  SECTOR_OF_WORST_CASE_PRODUCTS_ID: 7,
  MULTIPLE_PRODUCTS_BASED_ON_SEVERAL_REPRESENTATIVE_PRODUCTS_ID: 8,
};

export const OTHER_LCA_SOFTWARE_NAME = 'Other LCA software';

export const NORTH_AMERICA_PILOT_PCR = 'd84b0737-b003-4b56-f7e7-08dbd176102b';
